import { Column } from "@/components/Table/Table";

export const SALES_ORDER_UPLOAD_COLUMNS: Column[] = [
  {
    label: "Order ID",
    key: "order_id",
    searchable: true,
  },
  {
    label: "Order date",
    key: "order_date",
    sortable: true,
  },
  {
    label: "Product ID",
    key: "product_id",
    searchable: true,
  },
  {
    label: "Product Name",
    key: "product_name",
    searchable: true,
    maxWidth: "2fr",
  },
  {
    label: "Quantity",
    key: "quantity",
    sortable: true,
  },
  {
    key: "departure_facility",
    label: "Departure facility",
    searchable: true,
    maxWidth: "2fr",
    sortable: true,
  },
  {
    key: "arrival_facility",
    label: "Arrival facility",
    searchable: true,
    maxWidth: "2fr",
    sortable: true,
  },
  {
    key: "arrival_name",
    label: "Arrival name",
    searchable: true,
    maxWidth: "2fr",
    sortable: true,
  },
  {
    key: "arrival_address",
    label: "Arrival address",
    searchable: true,
    maxWidth: "2fr",
    sortable: true,
  },

  {
    key: "transport_category",
    label: "Transport category",
    searchable: true,
    sortable: true,
  },
];
